import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ToastController,
} from '@ionic/angular';
import { TrackingService } from '../../services/tracking.service';
import { UserStore } from '../../services/user.store';
import { BasePage } from '../base.page';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage extends BasePage {
  canvas: any;
  ctx: any;
  chart: any;

  constructor(
    protected loadingController: LoadingController,
    protected alertController: AlertController,
    protected toastController: ToastController,
    protected route: ActivatedRoute,
    public userStore: UserStore,
    protected track: TrackingService
  ) {
    super(loadingController, alertController, toastController, route, track);
    this.track.pageView('Dashboard');
  }

  // ngAfterViewInit() {
  // this.route.data.subscribe((resolver: any) => {
  //   const labels = [];
  //   const dataSets = [];
  //   const gross = [];
  //   const expenses = [];
  //   const net = [];
  //   const occupancy = [];

  //   resolver.stats.forEach((stat: DashboardStat) => {
  //     labels.push(stat.areaName);
  //     gross.push(stat.grossAmount);
  //     expenses.push(stat.expenseAmount);
  //     net.push(stat.netAmount);
  //     occupancy.push(stat.occupancy);
  //   });

  //   dataSets.push({
  //     label: 'Gross',
  //     stack: 'A',
  //     backgroundColor: 'yellow',
  //     yAxisID: 'A1',
  //     data: gross,
  //   });

  //   dataSets.push({
  //     label: 'Expenses',
  //     stack: 'A',
  //     backgroundColor: 'red',
  //     yAxisID: 'A1',
  //     data: expenses,
  //   });

  //   dataSets.push({
  //     label: 'Net',
  //     stack: 'A',
  //     backgroundColor: 'green',
  //     yAxisID: 'A1',
  //     data: net,
  //   });

  //   dataSets.push({
  //     label: 'Occupancy',
  //     type: 'bar',
  //     stack: 'B',
  //     backgroundColor: 'blue',
  //     yAxisID: 'B',
  //     data: occupancy,
  //   });

  //   this.canvas = document.getElementById('dashboardChart');
  //   this.ctx = this.canvas.getContext('2d');
  //   if (this.chart) {
  //     this.chart.destroy();
  //   }
  //   this.chart = new Chart(this.ctx, {
  //     type: 'bar',
  //     data: {
  //       labels,
  //       datasets: dataSets,
  //     },
  //     options: {
  //       responsive: true,
  //       scales: {
  //         xAxes: [
  //           {
  //             stacked: true,
  //             barPercentage: 0.4
  //           },
  //         ],
  //         yAxes: [
  //           {
  //             id: 'A1',
  //             position: 'left',
  //             stacked: true,
  //             scaleLabel: {
  //               display: true,
  //               labelString: 'Gross/Expenses/Net ($)',
  //             },
  //             ticks: {
  //               callback: function(label, index, labels) {
  //                 return label / 1000 + 'k';
  //               },
  //             },
  //           },
  //           {
  //             id: 'B',
  //             position: 'right',
  //             stacked: true,
  //             scaleLabel: {
  //               display: true,
  //               labelString: 'Occupancy (%)',
  //             },
  //             ticks: {
  //               max: 100,
  //               min: 0,
  //             },
  //           },
  //         ],
  //       },
  //     },
  //   });
  // });
  // }
}
